module.exports = __webpack_public_path__ + "static/media/BannerSegMais.c80a776f.png";